import { combineReducers, configureStore } from '@reduxjs/toolkit';
import globalReducer from './slices/global/index';
import ralliesPreviewReducer from './slices/ralliesPreview/index';
import rallyGameReducer from './slices/rallyGame/index';
import adminAuthReducer from './adminSlices/auth/index';
import adminFaqReducer from './adminSlices/faq/index';
import adminRalliesReducer from './adminSlices/rallies/index';
import institutionsReducer from './adminSlices/institutions/index';
import editorsReducer from './adminSlices/editors/index';
import clipboardReducer from './adminSlices/clipboard/index';
import { useDispatch } from 'react-redux';
const rootReducer = combineReducers({
    global: globalReducer,
    ralliesPreview: ralliesPreviewReducer,
    rallyGame: rallyGameReducer,
    adminAuth: adminAuthReducer,
    adminFaq: adminFaqReducer,
    adminRallies: adminRalliesReducer,
    institutions: institutionsReducer,
    editors: editorsReducer,
    clipboard: clipboardReducer,
});
export const store = configureStore({
    reducer: rootReducer,
});
export const useAppDispatch = useDispatch;
